<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        :breadcrumbs="breadcrumbs"
        icon="mdi-format-list-checkbox"
    ></vuse-section-definition>
    <div class="d-flex">
      <v-col cols="6" class="ml-3 mx-1 rounded content_warranty">
        <div class="ma-10">
          <div class="font-weight-bold">Thông tin sản phẩm</div>
          <hr class="border_bottom">
          <v-row class="mt-5">
            <v-col cols="12">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  :text="warranty.stamp"
                  v-model="warranty.stamp"
                  label="Mã tem sản phầm"
                  placeholder="Mã tem sản phầm"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  :text="warranty.name_product"
                  v-model="warranty.name_product"
                  label="Tên sản phầm"
                  placeholder="Tên sản phầm"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  :text="warranty.seri"
                  v-model="warranty.seri"
                  label="Seriel"
                  placeholder="Seriel"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-menu
                  v-model="menu3"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      background-color="#EDF2F7"
                      filled
                      v-model="buy"
                      label="Ngày mua hàng"
                      append-icon="mdi-calendar"
                      readonly
                      @blur="dateBuy = parseDate(buy)"
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="dateBuy"
                    @input="menu3 = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  :text="warranty.time"
                  v-model="warranty.time"
                  label="Thời gian bảo hành (tháng)"
                  placeholder="Nhập thời gian bảo hành"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      background-color="#EDF2F7"
                      filled
                      v-model="startGame"
                      label="Ngày xuất kho"
                      append-icon="mdi-calendar"
                      readonly
                      @blur="dateStart = parseDate(startGame)"
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="dateStart"
                    @input="menu1 = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6">
              <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      background-color="#EDF2F7"
                      filled
                      v-model="endGame"
                      label="Ngày kết thúc bảo hành"
                      append-icon="mdi-calendar"
                      readonly
                      @blur="dateEnd = parseDate(endGame)"
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="dateEnd"
                    @input="menu2 = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
<!--            <v-col cols="6">-->
<!--              <v-select-->
<!--                  filled-->
<!--                  class="width-input"-->
<!--                  background-color="#EDF2F7"-->
<!--                  v-model="warranty.status"-->
<!--                  :items="active"-->
<!--                  item-text="name"-->
<!--                  item-value="id"-->
<!--                  label="Chọn trạng thái kích hoạt"-->
<!--              ></v-select>-->
<!--            </v-col>-->
            <v-col cols="6">
              <v-select
                  filled
                  class="width-input"
                  background-color="#EDF2F7"
                  v-model="warranty.warranty_status"
                  :items="warranty_status"
                  item-text="name"
                  item-value="id"
                  label="Chọn trạng thái bảo hành"
              ></v-select>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="6">
        <v-row>
          <v-col cols="12" class="mr-3 mx-1 rounded content_warranty" >
            <div class="ma-10">
              <div class="font-weight-bold">Thông tin đại lý*</div>
              <hr class="border_bottom">
              <v-row class="mt-5">
                <v-col cols="6">
                  <v-text-field
                      background-color="#EDF2F7"
                      filled
                      v-model="warranty.fullname"
                      label="Họ tên"
                      placeholder="Họ tên"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                      background-color="#EDF2F7"
                      filled
                      v-model="warranty.phone"
                      label="Số điện thoại"
                      placeholder="Số điện thoại"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                      background-color="#EDF2F7"
                      filled
                      v-model="warranty.email"
                      label="Email"
                      placeholder="Email"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                      background-color="#EDF2F7"
                      filled
                      v-model="warranty.address"
                      label="Địa chỉ"
                      placeholder="Địa chỉ"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col cols="12" class="mr-3 mx-1 mt-2 rounded content_warranty" >
            <div class="ma-10">
              <div class="font-weight-bold">Thông tin khách hàng</div>
              <hr class="border_bottom">
              <v-row class="mt-5">
                <v-col cols="6">
                  <v-text-field
                      background-color="#EDF2F7"
                      filled
                      v-model="warranty.customer_fullname"
                      label="Họ tên"
                      placeholder="Họ tên"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                      background-color="#EDF2F7"
                      filled
                      v-model="warranty.customer_phone"
                      label="Số điện thoại"
                      placeholder="Số điện thoại"
                  ></v-text-field>
                </v-col>
<!--                <v-col cols="12">-->
<!--                  <v-text-field-->
<!--                      background-color="#EDF2F7"-->
<!--                      filled-->
<!--                      v-model="warranty.customer_email"-->
<!--                      label="Email"-->
<!--                      placeholder="Email"-->
<!--                  ></v-text-field>-->
<!--                </v-col>-->
                <v-col cols="12">
                  <v-text-field
                      background-color="#EDF2F7"
                      filled
                      v-model="warranty.customer_address"
                      label="Địa chỉ"
                      placeholder="Địa chỉ"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </div>
    <div class="justify-center text-center my-5">
      <v-btn color="primary" width="180" @click="update_warranty">
        Lưu
      </v-btn>
    </div>
  </div>
</template>
<script>
import {
  SAVE_WARRANTY,
} from "@/store/modules/warranty";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      dateStart: "",
      startGame:"",
      dateEnd:"",
      buy:"",
      endGame:"",
      dateBuy:"",
      menu1:false,
      menu2:false,
      menu3:false,
      page: "Thêm mới",
      active: [
        {id:1, name:'CHƯA BẢO HÀNH'},
        {id:2, name:'ĐÃ BẢO HÀNH'},
      ],
      warranty_status: [
        {id:1, name:'CHƯA KÍCH HOẠT'},
        {id:2, name:'ĐÃ KÍCH HOẠT'},
        {id:3, name:'KHÔNG KÍCH HOẠT'},
      ],
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true
        },
        {
          text: "Bảo hành",
          disabled: true,
        },
        {
          text: "Kích hoạt bảo hành",
          disabled: true,
        },
        {
          text: "Thêm mới",
          disabled: true,
        },
      ],
      warranty: {
        address: '',
        buy_date: '',
        email:'',
        end_date:'',
        fullname:'',
        name_product:'',
        phone:'',
        seri:'',
        stamp:'',
        start_date:'',
        status:'',
        time:36,
        warranty_status:'',
        customer_fullname:'',
        customer_phone:'',
        customer_email:'',
        customer_address:'',
      }
    };
  },
  computed: {
    ...mapGetters({
      warranties: "warranties",
    }),
  },
  watch: {
    // warranty(val) {
    //   this.dateBuy = val.buy_date
    //   this.dateStart = val.start_date
    //   this.dateEnd = val.end_date
    // }
    ['warranty.time'](value) {
      if (this.dateBuy) {
        const newDate = this.addMonth(this.dateBuy, parseInt(value));
        this.dateEnd = newDate
      }
    },
    dateEnd() {
      this.endGame = this.formatDate(this.dateEnd)
    },
    dateStart() {
      if (this.dateStart) {
        this.startGame = this.formatDate(this.dateStart)
      }

    },
    dateBuy() {
      if (this.dateBuy) {
        this.buy = this.formatDate(this.dateBuy);
        this.dateEnd = this.addMonth(this.dateBuy, this.warranty.time);
      }
    }
  },
  mounted() {
    this.buy = this.warranty.buy_date
    this.startGame = this.warranty.start_date
    this.endGame = this.warranty.end_date
  },

  methods: {
    addMonth(date, month) {
      let currentDate = new Date(date)
      let newDate = new Date(currentDate.setMonth(currentDate.getMonth()+month))
      let endDate = (newDate.toISOString()).substring(0,10)
      // let year = parseInt(date.split('-')[0])+parseInt(years);
      // let newDate = year+'/'+date.split('-')[1]+'/'+date.split('-')[2]
      return endDate;
    },
    formatDate(date) {
      if (!date) return null;
      let newDate = new Date(date);
      const [year, month, day] = [
        newDate.getFullYear(),
        newDate.getMonth() + 1,
        newDate.getDate(),
      ];
      let day_format = day > 9 ? day : `0${day}`;
      let month_format = month > 9 ? month : `0${month}`;

      return `${day_format}/${month_format}/${year}`;
    },
    parseDate (date) {
      if (!date) return null
      const [day,month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    update_warranty() {
      let params = {
        address: this.warranty.address,
        buy_date: this.dateBuy,
        email:this.warranty.email,
        end_date:this.dateEnd,
        fullname:this.warranty.fullname,
        name_product:this.warranty.name_product,
        phone:this.warranty.phone,
        seri:this.warranty.seri,
        stamp:this.warranty.stamp,
        start_date:this.dateStart,
        status:this.warranty.status,
        time:this.warranty.time,
        warranty_status:this.warranty.warranty_status,

      }
      this.$store.dispatch(`${SAVE_WARRANTY}`, params).then((data) => {
        if (data.data.status==1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration:1000,
            position:'top-center'
          })
          this.$router.push("/manage_warranty/list_warranty");
        } else {
          alert(data.data.errors)
        }
      });
    },
  }
};
</script>
<style scoped lang="scss">
.content_warranty {
  width: 50%; background: #ffffff;
  .v-input__control {
    height: 60px !important;
  }
}
.border_bottom {
  border: 1px solid lightgrey;
  width: 160px;
}

</style>